import ModalSignup, { SignupModalFormData } from './ModalSignup';

export type { SignupModalFormData };
export default ModalSignup;
